import { render, staticRenderFns } from "./ModalDeposit.vue?vue&type=template&id=163a5604"
import script from "./ModalDeposit.vue?vue&type=script&lang=js"
export * from "./ModalDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports